import React, { Component, Fragment } from "react";
import ReportScope, { readReportScope } from '../../reports/report-scope';
import { injectIntl } from "react-intl";
import { DatePicker, RangeDatePicker } from "jalali-react-datepicker";
import API from "../../../api/index";
var classNames = require("classnames");
import ReactTimeAgo from "react-time-ago";
import { NotificationManager } from "Components/ReactNotifications";
import moment from "jalali-moment";

import { logoutUser } from "Redux/actions";
import { batch, connect } from "react-redux";
import CustomSelectInput from "Components/CustomSelectInput";
import Select from "react-select";
import { Row, Card, CardBody, CardTitle, Button, Collapse, FormGroup, Label, Input, Form, Modal, ModalBody, ModalHeader, ModalFooter, timeoutsShape } from "reactstrap";

import NumberFormat from "react-number-format";
import { Colxx, Separator } from "Components/CustomBootstrap";

class archive extends Component {
	constructor(props) {
		super(props);

		this.state = {
			sms_isBatchesLoading: false,
			sms_targetBatchID: -1,
			sms_batches: [],
			sms_searchChanged: false,
			sms_isSending: false,
			sms_targetBatchMessage: "",

			leads: [],
			paging: [],
			isRefreshing: false,
			isLoading: true,
			toggleSearchForm: true,
			APIResetData: {},
			APISearchData: {},
			leadPulseTagName: "",
			search: {
				reportContext: readReportScope(props.location.search),
				smsBanned: this.props.match.params.smsBannedType == "banned" ? "BANNED" : "ALL",
				leadMobile: "",
				status: this.props.match.params.listType == "converted" ? "CONVERTED" : "ALL",
				leadPulseTagID: this.props.match.params.tagName,
				currentPage: 1,
			},
			smsModalOpen: false,
		};

		this.validateMobile = this.validateMobile.bind(this);
		this.setCreatedDateRange = this.setCreatedDateRange.bind(this);
		this.setClosedDateRange = this.setClosedDateRange.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.toggleSearchForm = this.toggleSearchForm.bind(this);
		this.doSearch = this.doSearch.bind(this);
		this.doReset = this.doReset.bind(this);
		this.cleanCustomerMobile = this.cleanCustomerMobile.bind(this);
		this.loadData = this.loadData.bind(this);

		this.syntaxHighlight = this.syntaxHighlight.bind(this);
		this.smsModalToggle = this.smsModalToggle.bind(this);
		this.smsFilters = this.smsFilters.bind(this);
		this.smsModalOpened = this.smsModalOpened.bind(this);
		this.smsSend = this.smsSend.bind(this);
	}
	smsSend() {
		this.setState({ sms_isSending: true });
		API.sms.batch
			.send({ audience: "LEAD", messageType: "ADVERTISING", batchID: this.state.sms_targetBatchID, searchConditions: this.smsFilters() })
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				if (data.DONE) {
					alert("تعداد کل موبایل ها: " + data.COUNT.TOTAL + "\n" + "تعداد موبایل های مسدود: " + data.COUNT.BANNED + "\n" + "تعداد نهایی برای ارسال: " + data.COUNT.FINAL + "\n");
					this.props.history.push("/app/sms/batch", { tabDefaultIndex: 1 });
				}
			})
			.catch((error) => {
				console.log(error);
				this.setState({
					sms_isSending: false,
				});
			});
	}
	smsFilters() {
		var filters = this.state.search;
		delete filters.currentPage;
		return filters;
	}
	smsModalOpened() {
		this.setState({ sms_isBatchesLoading: true });
		API.sms.batch
			.list({ audience: "LEAD" })
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				this.setState({
					sms_batches: data.batches,
					sms_isBatchesLoading: false,
				});
			})
			.catch((error) => {});
	}
	smsModalToggle() {
		this.setState({
			smsModalOpen: !this.state.smsModalOpen,
		});
	}
	syntaxHighlight(json) {
		json = json.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
		return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
			var cls = "number";
			if (/^"/.test(match)) {
				if (/:$/.test(match)) {
					cls = "key";
				} else {
					cls = "string";
				}
			} else if (/true|false/.test(match)) {
				cls = "boolean";
			} else if (/null/.test(match)) {
				cls = "null";
			}
			return `<span class="${cls}">${match}</span>`;
		});
	}
	cleanCustomerMobile(mobile) {
		mobile = mobile.split(" ").join("");
		mobile = mobile.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

		// console.log(mobile,mobile.indexOf("0098"))
		if (mobile.indexOf("0098") === 0) {
			mobile = mobile.replace("0098", "0");
		}
		if (mobile.indexOf("098") === 0) {
			mobile = mobile.replace("098", "0");
		}
		if (mobile.indexOf("+98") === 0) {
			mobile = mobile.replace("+98", "0");
		}
		if (mobile.indexOf("98") === 0) {
			mobile = mobile.replace("98", "0");
		}
		if (mobile.indexOf("9") === 0 && mobile.length == 10) {
			mobile = "0" + mobile;
		}
		return mobile;
	}
	componentDidMount() {
		this.setState(
			{
				APISearchData: JSON.parse(JSON.stringify(this.state.search)),
				APIResetData: JSON.parse(JSON.stringify(this.state.search)),
			},
			() => {
				this.loadData();
			}
		);
	}
	loadData() {
		this.setState({ reportError: '' });
		API.crm.lead
			.list(this.state.APISearchData)
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				this.setState({
					leads: data.leads,
					paging: data.paging,
					isLoading: false,
					isRefreshing: false,
					leadPulseTagName: data.leadPulseTagName,
					sms_searchChanged: false,
				});
			})
			.catch((error) => { this.setState({ isLoading: false, isRefreshing: false, reportError: 'دریافت فهرست ناموفق بود؛ دسترسی یا فیلتر گزارش را بررسی کنید.', paging: {pages:[],total:0,from:0,to:0,current:1}, orders:[],customers:[],leads:[],coupons:[] }); });
	}
	doSearch() {
		var tmpObj = JSON.parse(JSON.stringify(this.state.search));
		tmpObj.currentPage = 1;
		this.setState(
			{
				APISearchData: tmpObj,
				isRefreshing: true,
			},
			() => {
				this.loadData();
			}
		);
	}
	doReset() {
		this.setState(
			{
				search: JSON.parse(JSON.stringify(this.state.APIResetData)),
				APISearchData: JSON.parse(JSON.stringify(this.state.APIResetData)),
				isRefreshing: true,
			},
			() => {
				this.loadData();
			}
		);
	}
	handleFocus = (event) => event.target.select();
	setCreatedDateRange(start, end) {
		var tmpObj = this.state.search;
		tmpObj.createdFrom = start;
		tmpObj.createdTo = end;
		this.setState({ search: tmpObj });
	}
	setClosedDateRange(start, end) {
		var tmpObj = this.state.search;
		tmpObj.closedFrom = start;
		tmpObj.closedTo = end;
		this.setState({ search: tmpObj });
	}
	validateMobile(mobile) {
		if (mobile.trim() == "") {
			return false;
		}
		return mobile.match(/^(0)+(9|$)\d{9}$/g) != null;
	}
	toggleSearchForm() {
		const prevState = this.state.toggleSearchForm;
		this.setState({
			toggleSearchForm: !prevState,
		});
	}

	render() {
		return this.state.isLoading ? (
			<div className="loading"></div>
		) : (
			<Fragment>
				<Row className="mb-4 searchdropdown">
					<Colxx xxs="12">
						<Card>
							<CardBody>
								<ReportScope scope={this.state.search.reportContext} error={this.state.reportError} />
								<CardTitle>
									<div
										onClick={(e) => {
											this.props.history.push("/app/crm/lead/");
										}}
										className="breadcrumb-item"
									>
										<div className={"iconsminds-leaning-tower headingicon"} /> سرنخ ها
									</div>
									<span className="breadcrumb-arrow" style={{ marginLeft: "10px" }}>
										{" > "}
									</span>
									<div className={"iconsminds-data-center headingicon"} />
									{classNames({
										"لیست همه سرنخ ها": this.props.match.params.listType !== undefined && this.props.match.params.listType !== "converted",
										"لیست  سرنخ های تبدیل شده": this.props.match.params.listType !== undefined && this.props.match.params.listType == "converted",
										" لیست  سرنخ ها با پالس ": this.props.match.params.listType === undefined && this.props.match.params.tagName !== undefined,
									})}
									{this.props.match.params.listType === undefined && this.props.match.params.tagName !== undefined ? (
										<strong
											style={{
												textDecoration: "underline",
											}}
										>
											{this.state.leadPulseTagName}
										</strong>
									) : (
										<span />
									)}

									<div
										className={"text-muted"}
										style={{
											float: "left",
											fontSize: "14px",
										}}
									>
										{" نمایش "}
										{<NumberFormat value={this.state.paging.from + 1} displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <span>{value}</span>} />}
										{" تا "}
										{<NumberFormat value={this.state.paging.to} displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <span>{value}</span>} />}
										{" از "}
										{<NumberFormat value={this.state.paging.total} displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <span>{value}</span>} />}
										{" سرنخ"}
									</div>
								</CardTitle>

								<Fragment>
									<div className="border productPanel ">
										<Button block color="link" className="text-right" onClick={() => this.toggleSearchForm()} aria-expanded={this.state.toggleSearchForm}>
											<i
												className="glyph-icon simple-icon-magnifier"
												style={{
													marginLeft: "5px",
													fontSize: "14px",
												}}
											></i>
											فرم جستجو
											<i
												className="glyph-icon simple-icon-arrow-down"
												style={{
													marginRight: "10px",
													fontSize: "10px",
												}}
											></i>
										</Button>
										<div
											className="dropdown-buttons"
											style={{
												float: "left",
												display: this.state.toggleSearchForm ? "inline-block" : "none",
											}}
										>
											<Button
												color="info"
												style={{
													float: "left",
													padding: 5,
													paddingTop: 8,
												}}
												className={"default sms-send-button"}
												onClick={() => {
													this.setState({
														smsModalOpen: true,
													});
												}}
												disabled={this.state.sms_searchChanged || this.state.search.status != "NOT_CONVERTED"}
											>
												<i
													className="iconsminds-mail-send"
													style={{
														fontSize: 24,
														fontWeight: 800,
														height: 20,
														display: "inline-block",
													}}
												></i>
												&nbsp;
											</Button>
											<Button
												color="primary"
												style={{
													float: "left",
													marginLeft: "10px",
												}}
												className={"default"}
												onClick={this.doSearch}
											>
												جستجو کن
											</Button>
											<Button
												color="light"
												style={{
													float: "left",
													marginLeft: "10px",
												}}
												className={"default"}
												onClick={this.doReset}
											>
												ریست
											</Button>
										</div>
										<Collapse isOpen={this.state.toggleSearchForm} style={{ paddingTop: "10px" }}>
											<div className="p-4">
												<Row className="mb-4">
													<Colxx xxs="12">
														<Form>
															<FormGroup row>
																<Colxx sm={2}>
																	<FormGroup className={"filter " + (this.validateMobile(this.state.search.leadMobile) ? "filter-active" : "")}>
																		<Label for="leadMobile">موبایل سرنخ ( شروع با )</Label>
																		<Input
																			type="text"
																			name="leadMobile"
																			id="leadMobile"
																			onClick={this.handleFocus}
																			placeholder="09123456789"
																			value={this.state.search.leadMobile}
																			onChange={(e) => {
																				this.setState({
																					sms_searchChanged: true,
																				});
																				var cleanValue = this.cleanCustomerMobile(e.target.value);
																				var tmpObj = {
																					...this.state.search,
																				};
																				tmpObj.leadMobile = cleanValue;
																				this.setState({
																					search: tmpObj,
																				});
																			}}
																		/>
																	</FormGroup>
																</Colxx>
																<Colxx sm={2}>
																	<FormGroup className={"filter " + (this.state.search.status != "ALL" ? "filter-active" : "")}>
																		<Label>وضعیت</Label>
																		<Input
																			type="select"
																			disabled={this.props.match.params.listType == "converted"}
																			onChange={(e) => {
																				this.setState({
																					sms_searchChanged: true,
																				});
																				var tmpObj = {
																					...this.state.search,
																				};
																				tmpObj.status = e.target.value;
																				this.setState({
																					search: tmpObj,
																				});
																			}}
																			value={this.state.search.status}
																		>
																			<option value="ALL">همه وضعیت ها</option>
																			<option value="CONVERTED">فقط تبدیل شده ها</option>
																			<option value="NOT_CONVERTED">فقط تبدیل نشده ها</option>
																		</Input>
																	</FormGroup>
																</Colxx>
																<Colxx sm={2}>
																	<FormGroup className={"filter " + (this.state.search.smsBanned != "ALL" ? "filter-active" : "")}>
																		<Label>دریافت پیامک</Label>
																		<Input
																			type="select"
																			disabled={this.props.match.params.smsBannedType == "converted"}
																			onChange={(e) => {
																				this.setState({
																					sms_searchChanged: true,
																				});
																				var tmpObj = {
																					...this.state.search,
																				};
																				tmpObj.smsBanned = e.target.value;
																				this.setState({
																					search: tmpObj,
																				});
																			}}
																			value={this.state.search.smsBanned}
																		>
																			<option value="ALL">همه</option>
																			<option value="BANNED">مسدود</option>
																		</Input>
																	</FormGroup>
																</Colxx>
																<Colxx sm={4}>
																	<FormGroup className={"filter " + (this.props.match.params.tagName !== undefined ? "filter-active" : "")}>
																		<Label>پالس</Label>
																		<Select
																			components={{
																				Input: CustomSelectInput,
																			}}
																			className={classNames({
																				"react-select": true,
																				"react-select-error": this.state.PulseTag === -1,
																			})}
																			classNamePrefix="react-select"
																			isMulti={true}
																			name="form-field-name"
																			disabled={true}
																			value={[
																				{
																					label: this.props.match.params.tagName !== undefined ? this.state.leadPulseTagName : "همه",
																					value: "-1",
																					key: 0,
																				},
																			]}
																		/>
																	</FormGroup>
																</Colxx>
															</FormGroup>
														</Form>
													</Colxx>
												</Row>
											</div>
										</Collapse>
									</div>
									<br />
								</Fragment>
								{!this.state.isRefreshing ? (
									<div className="table-responsive">
										<table className="table table-hover order-table">
											<thead>
												<tr>
													<th>شماره سرنخ</th>
													<th>زمان ثبت</th>
													<th>زمان تبدیل </th>
													<th>موبایل</th>
													<th>تبدیل شده </th>
													<th>تعداد پالس ها </th>
													<th>پالس ها</th>
													<th>اپراتور</th>
													<th>
														<i className={"iconsminds-mail-settings"} ></i>
													</th>
												</tr>
											</thead>

											{this.state.leads.map((row) => (
												<TableBodyRows key={row.LeadID} data={row} />
											))}

											<tfoot>
												<tr>
													<td colSpan={12}>
														<div className="table-pagination">
															{this.state.paging.pages.map((page, index) => (
																<Button
																	key={index}
																	className={classNames({
																		"mb-2": true,
																		"pagination-item": true,
																		"pagination-number": true,
																		"pagination-current": page.current,
																	})}
																	onClick={(e) => {
																		if (page.ellipse) {
																			return;
																		}
																		var tmpObj = {
																			...this.state.APISearchData,
																		};
																		tmpObj.currentPage = page.page;
																		this.setState(
																			{
																				APISearchData: tmpObj,
																				isRefreshing: true,
																			},
																			() => {
																				this.loadData();
																			}
																		);
																	}}
																>
																	{page.page}
																</Button>
															))}
														</div>
													</td>
												</tr>
											</tfoot>
										</table>
									</div>
								) : (
									<div
										className="loading"
										style={{
											left: "unset",
											top: "unset",
											position: "relative",
											display: "block",
											marginLeft: "auto",
											marginRight: "auto",
										}}
									></div>
								)}
							</CardBody>
						</Card>
					</Colxx>
				</Row>
				<Modal onOpened={this.smsModalOpened} isOpen={this.state.smsModalOpen} toggle={this.smsModalToggle}>
					<ModalHeader toggle={this.smsModalToggle}>ارسال پیامک دسته ای</ModalHeader>
					<ModalBody>
						<table>
							<tbody>
								<tr>
									<th>نوع:</th>
									<td>سرنخ</td>
								</tr>
								<tr>
									<th>تعداد کل:</th>
									<td>{<NumberFormat value={this.state.paging.total} displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <span>{value}</span>} />}</td>
								</tr>
								<tr>
									<th>فیلتر ها:</th>
									<td>
										<pre
											style={{
												direction: "ltr !important",
												textAlign: "left",
												width: "330px",
											}}
											className={"jsonsyntax"}
											dangerouslySetInnerHTML={{
												__html: this.syntaxHighlight(JSON.stringify(this.smsFilters(), null, 2)),
											}}
										></pre>
									</td>
								</tr>
								<tr>
									<th>دسته:</th>
									<td>
										<Input
											type="select"
											onChange={(e) => {
												this.setState({
													sms_targetBatchID: e.target.value,
													sms_targetBatchMessage: this.state.sms_batches.filter(function (batch) {
														return batch.BatchID == e.target.value;
													})[0].Message,
												});
											}}
											value={this.state.sms_targetBatchID}
										>
											<option value="-1">{this.state.sms_isBatchesLoading ? "..." : "انتخاب کنید"}</option>
											{this.state.sms_batches.map((batch) => (
												<option key={"batch-" + batch.BatchID} value={batch.BatchID}>
													{batch.Name}
												</option>
											))}
										</Input>
									</td>
								</tr>
								<tr>
									<th>پیام:</th>
									<td>
										<div
											style={{ background: "#e5e5ea", width: "330px", padding: "10px", borderRadius: "10px", float: "Left", borderBottomLeftRadius: "" }}
											dangerouslySetInnerHTML={{
												__html: this.state.sms_targetBatchMessage,
											}}
										></div>
									</td>
								</tr>
							</tbody>
						</table>
					</ModalBody>
					<ModalFooter>
						<Button
							color="info"
							style={{ float: "left" }}
							className={"default"}
							onClick={() => {
								this.smsSend();
							}}
							disabled={this.state.sms_searchChanged || this.state.sms_isSending}
						>
							ارسال
						</Button>
					</ModalFooter>
				</Modal>
			</Fragment>
		);
	}
}

class TableBodyRows extends Component {
	render() {
		const {
			data: { LeadID, CreatedAt, ConvertedAt, Converted, LeadMobile, Pulses, PulsesCount, OperatorName,smsBanned },
		} = this.props;
		return (
			<tbody>
				<tr className={"order-spacer"}></tr>
				<tr className={"order-item"}>
					<td className={"text-muted"}>{LeadID}</td>
					<td className={"text-muted"}>{moment(CreatedAt).locale("fa").format("DD / MMMM / YYYY - HH:mm")}</td>
					<td className={"text-muted"}>{ConvertedAt !== null ? moment(ConvertedAt).locale("fa").format("DD / MMMM / YYYY - HH:mm") : "-"}</td>
					<td>
						<a href={"/app/crm/lead/view/" + LeadMobile} target="_blank">
							{" "}
							{LeadMobile} <div className={" simple-icon-arrow-left-circle icongotoorder"} />
						</a>
					</td>
					<td className={"text-muted"}>
						<div
							className={classNames({
								"simple-icon-check": Converted === "1",
								"simple-icon-options": Converted === "0",
							})}
						/>
					</td>
					<td className={"text-muted"}>{PulsesCount}</td>
					<td className={"text-muted"}>
						<ul className={"pulses"}>
							{Pulses.map((Pulse, index) => {
								return (
									<li key={index}>
										{Pulse.TagName} <span className={"pulsecount"}>{Pulse.Count}</span>
									</li>
								);
							})}
						</ul>
					</td>
					<td className={"text-muted"}>{OperatorName}</td>
					<td className={"text-muted"}>
						<i
							style={{ color: smsBanned ? "darkorange" : "#98abb4", fontWeight: smsBanned ? "bold" : "default" }}
							className={classNames({
								"simple-icon-ban": smsBanned,
								"simple-icon-check": !smsBanned,
							})}
						></i>
					</td>
				</tr>
			</tbody>
		);
	}
}

const mapStateToProps = ({ menu, settings }) => {
	return { logoutUser };
};
export default injectIntl(connect(mapStateToProps, { logoutUser })(archive));
// export default injectIntl(archive);
